import { render } from "./VideoDialog.vue?vue&type=template&id=65c99fc4&scoped=true&lang=pug"
import script from "./VideoDialog.js?vue&type=script&lang=js&external"
export * from "./VideoDialog.js?vue&type=script&lang=js&external"

import "./VideoDialog.vue?vue&type=style&index=0&id=65c99fc4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c99fc4"]])

export default __exports__